import {extendsAPIServices} from "./APIServices";
import getEnv from "../../helpers/common/getEnv";
import {GET} from "../../constants/HTTPConstants";

const baseAdminAPI = getEnv('basePaymentAPI');
const api = extendsAPIServices(baseAdminAPI);

export const _getListBilling = (page = 1, limit) => {
    return api.makeAuthRequest({
        method: GET,
        url: '/bills/all',
        params: {
            page,
            limit,
        }
    })
}


// WEBPACK FOOTER //
// ./src/services/apis/BillingsService.js